export function torontoDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(now);
  const part = type => parts.find(value => value.type === type).value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}

function validDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split('-').map(Number);
  if (year < 1000 || year > 9999) return false;
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

export function messageIsActive({ enabled = true, start = '', end = '', text = '' }, today, previewAll = false) {
  if (!enabled) return false;
  if (previewAll) return true;
  start = start.trim();
  end = end.trim();
  if ((start && !validDate(start)) || (end && !validDate(end))) return false;
  if (start && end && end < start) return false;
  if (start && today < start) return false;
  if (end && today > end) return false;
  if (start || end) return true;

  const match = text.toLowerCase().match(/until ([a-z]{3})[a-z]*[.]? ([0-9]{1,2})/);
  if (!match) return true;
  const month = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].indexOf(match[1]);
  if (month < 0) return true;
  let year = Number(today.slice(0, 4));
  const current = Date.parse(`${today}T00:00:00Z`);
  if (Date.UTC(year, month, Number(match[2])) - current > 183 * 86400000) year -= 1;
  const legacyEnd = `${year}-${String(month + 1).padStart(2, '0')}-${match[2].padStart(2, '0')}`;
  return !validDate(legacyEnd) || today <= legacyEnd;
}

if (typeof customElements !== 'undefined' && !customElements.get('jd-scheduled-announcement')) {
  customElements.define('jd-scheduled-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.bar) return;
      const template = this.querySelector('template');
      if (!template?.content.firstElementChild) return;
      let target = null;
      try {
        if (this.dataset.target) target = document.querySelector(this.dataset.target);
      } catch { return; }
      if (this.dataset.target && !target) return;
      this.bar = template.content.firstElementChild.cloneNode(true);
      this.messages = Array.from(this.bar.querySelectorAll('[data-jd-announcement-message]'));
      this.refresh = () => {
        const today = torontoDate();
        const previewAll = this.dataset.previewAll === 'true';
        this.messages.forEach(message => {
          message.hidden = !messageIsActive({
            enabled: message.dataset.enabled !== 'false',
            start: message.dataset.start || '',
            end: message.dataset.end || '',
            text: message.textContent
          }, today, previewAll);
        });
        this.bar.hidden = !this.messages.some(message => !message.hidden);
      };
      this.refresh();
      if (getComputedStyle(document.documentElement).direction === 'rtl') {
        this.bar.querySelectorAll('[data-jd-announcement-track]').forEach(track => track.classList.add('reverse'));
      }
      if (target) target.before(this.bar);
      else this.append(this.bar);
      this.interval = setInterval(this.refresh, 30000);
      this.onVisible = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onVisible);
      window.addEventListener('pageshow', this.refresh);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.onVisible);
      window.removeEventListener('pageshow', this.refresh);
      this.bar?.remove();
      this.bar = null;
    }
  });
}
